import {Injectable} from '@angular/core';
import {
  SearchResultHistory,
  SearchResultHistoryStore
} from '@app/core/state/search-result-history/search-result-history.store';
import {ListEntry} from '@app/shared/list/list.component';
import {KeyValue} from '@pezi/entities';
import {addEntities, getEntity, upsertEntities} from "@ngneat/elf-entities";

@Injectable({providedIn: 'root'})
export class SearchResultHistoryService {

  constructor(private searchResultHistoryStore: SearchResultHistoryStore) {
  }

  getSearchResultHistory(historyId: string) {
    if (this.searchResultHistoryStore.data.getValue()) {
      return this.searchResultHistoryStore.data.query(getEntity(historyId));
    }
    return null;
  }

  setSearchResultHistory(historyId: string, results: ListEntry<any>[]): void {
    if (this.searchResultHistoryStore.data.getValue()) {
      this.searchResultHistoryStore.data.update(upsertEntities(
        {
          id: historyId,
          results: results
        } as SearchResultHistory
      ));
    } else {
      this.searchResultHistoryStore.data.update(addEntities(
        {
          id: historyId,
          results: results
        } as SearchResultHistory
      ));
    }

  }

  setSearchResultHistoryPastSearch(historyId: string, search: KeyValue<string, any>[]): void {
    if (this.searchResultHistoryStore.data.getValue()) {
      this.searchResultHistoryStore.data.update(upsertEntities(
        {
          id: historyId,
          search: search
        } as SearchResultHistory
      ));
    } else {
      this.searchResultHistoryStore.data.update(addEntities(
        {
          id: historyId,
          search: search
        } as SearchResultHistory
      ));
    }

  }

  clearSearchResultHistoryStore() {
    this.searchResultHistoryStore.data.reset();
  }
}
